"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const react_1 = __importDefault(require("react"));
const CloseIcon = (props) => (react_1.default.createElement("svg", Object.assign({ viewBox: "0 0 12 12" }, props, { width: "12px", height: "12px", fill: "#a0a0a0" }),
    react_1.default.createElement("polygon", { points: "7.42 6 12 1.42 10.58 0 6 4.58 1.42 0 0 1.42 4.58 6 0 10.58 1.42 12 6 7.42 10.58 12 12 10.58 7.42 6" })));
exports.CloseIcon = CloseIcon;
//# sourceMappingURL=CloseIcon.js.map